import { ModulesMaster } from './modules-master.model';

export class ModulesSubmodulesPermissionsMaster {
    moduleDTOs:ModulesMaster[] = [];
}
